<template>
  <div class="sidebar-right" :class="{ 'hidden': hidden }">
    <div id="viewer-action-details" class="viewer-action-details"><slot></slot></div>
  </div>
</template>

<script>

export default {
  data: function() {
    return  { hidden: false };
  },
  methods: {
    hide: function() { this.hidden = true },
    show: function() { this.hidden = false },
    toggle: function() { this.hidden = !this.hidden }
  }
}
</script>

<style lang="scss" scoped>
div.hidden {
  visibility: hidden;
}

#viewer-action-details {
  position: absolute;
}
</style>
